module.exports = __webpack_public_path__ + "resources/img/img_nginx2.d0d53ba8eccdc96223f7c733eb36e4c9.png";